import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../assets/stylesheets/Dialogs/QuitMemberClub.scss';

const QuitMemberClub =() => {
    const { t } = useTranslation();
    return (
        <div className={`quitClub`}>
            <div>{t('areYouSureYouWantToQuitTheClub')}</div>
        </div>
    );
};

export default QuitMemberClub;
